import { IntlMessageId } from "shared/lang";

export const EOY_MONTHS = new Set([0, 1, 10, 11]); // Jan, Feb, Nov, Dec
export const MID_MONTHS = new Set([5, 6, 7]); // Jun, Jul, Aug

export const periodKeys: Record<"eoy" | "mid" | "other", IntlMessageId> = {
  eoy: "generic.inventoryPeriod.eoy",
  mid: "generic.inventoryPeriod.mid",
  other: "generic.inventoryPeriod.other",
};

export const getInventoryPeriodKey = (date: Date = new Date()): IntlMessageId => {
  const month = date.getMonth();
  if (EOY_MONTHS.has(month)) return periodKeys.eoy;
  if (MID_MONTHS.has(month)) return periodKeys.mid;
  return periodKeys.other;
};
